const Travel = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Travel and Tours</h1>
      </div>
      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
        <p>The travel and visa division provides specialised services in air ticketing for all
        domestic and international carriers, with complimentary insurance cover.</p>

        <p>Intiana, the travel and visa division of TCS (Pvt.) Limited, commenced its operations
        in 2004. Intiana provides specialised services in air ticketing for all domestic and 
        international carriers, with complimentary insurance cover. Whether the nature of travel is business,
        pleasure or spiritual, the company offers exclusive, customised packages to its customers, to suit
        their budgeting needs.</p>

        <p>Customers can personalise their Umrah experience and make their travel plans easy and convenient
        with special, all-inclusive packages, that also include various hotel accommodation options at extremely
        competitive rates. Customers can also avail our multiple worldwide destination tour packages, which include
        complimentary travel insurance. Intiana’s value-added services assist customers with visa processing, arrival
        and departure, and transportation to and from various airports.</p>
      </div>
    </div>
  );
};

export default Travel;
